import React from "react";

function LandingUniveralNumbersLoadingSkeleton() {
  return (
    <>
      {/* Lecturers Skeleton */}
      <div className="flex flex-col justify-center items-center gap-2 min-w-[250px] sm:py-1">
        <div className="w-20 h-10 bg-gray-200 rounded animate-pulse"></div>
        <div className="w-24 h-6 bg-gray-200 rounded animate-pulse"></div>
      </div>
      {/* Students Skeleton */}
      <div className="flex flex-col justify-center items-center gap-2 min-w-[250px] sm:py-1 border-x md:border-r-0 sm:border-x-0 border-gray-200">
        <div className="w-20 h-10 bg-gray-200 rounded animate-pulse"></div>
        <div className="w-24 h-6 bg-gray-200 rounded animate-pulse"></div>
      </div>
      {/* Study Program Skeleton */}
      <div className="flex flex-col justify-center items-center gap-2 min-w-[250px] sm:py-1">
        <div className="w-12 h-10 bg-gray-200 rounded animate-pulse"></div>
        <div className="w-32 h-6 bg-gray-200 rounded animate-pulse"></div>
      </div>
      {/* Alumni Skeleton */}
      <div className="flex flex-col justify-center items-center gap-2 min-w-[250px] sm:py-1 border-x md:border-r-0 sm:border-x-0 border-gray-200">
        <div className="w-20 h-10 bg-gray-200 rounded animate-pulse"></div>
        <div className="w-24 h-6 bg-gray-200 rounded animate-pulse"></div>
      </div>
    </>
  );
}

export default LandingUniveralNumbersLoadingSkeleton;
